/* eslint-disable camelcase */
import { invisiblyApi } from '../../../redux/api/invisibly-api';
import { InvisiblyApiResponse } from '../../../services/api/api-response.types';
import { ScreenshotterItem, ScreenShotterParams } from '../types/screenshotter.types';

const geoMapperEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getScreenShotterUrl: builder.query<string, ScreenShotterParams>({
      query: (params) => ({
        method: 'GET',
        url: 'b2b/screenshotter/generate',
        params: {
          target_url: params.target_url,
          asset_url: params.asset_url,
          mode: params.mode,
          bg: params.bg,
        },
      }),
      transformResponse(response: InvisiblyApiResponse<string>) {
        return response.item;
      },
    }),
    createScreenshotter: builder.mutation<ScreenshotterItem, void>({
      query: (params) => ({
        method: 'POST',
        url: 'b2b/screenshotter',
        data: params,
      }),
      transformResponse(response: InvisiblyApiResponse<ScreenshotterItem>) {
        return response.item;
      },
    }),
    getScreenshotterItems: builder.query<ScreenshotterItem[], void>({
      query: () => ({
        method: 'GET',
        url: 'b2b/screenshotter',
      }),
      transformResponse(response: InvisiblyApiResponse<ScreenshotterItem[]>) {
        return response.item;
      },
    }),
    getScreenshotterItem: builder.query<ScreenshotterItem, {id: string}>({
      query: ({id}) => ({
        method: 'GET',
        url: `b2b/screenshotter/${id}`,
      }),
      transformResponse(response: InvisiblyApiResponse<ScreenshotterItem>) {
        return response.item;
      },
    }),

    // getGeoMapperItem: builder.query<GeoMapperData, {id: string}>({
    //   query: ({id}) => ({
    //     method: 'GET',
    //     url: `b2b/geo_mapper/${id}`,
    //   }),
    //   transformResponse(response: InvisiblyApiResponse<GeoMapperData>) {
    //     return response.item;
    //   },
    // }),
    // uploadFile: builder.mutation<GeoMapperItem, {file: File}>({
    //   query: ({ file }) => {
    //     const fd = new FormData();
    //     console.log('uploading file', file);
    //     fd.append("file", file, file.name);
    //     return { url: 'b2b/geo_mapper', method: 'POST', data: fd };
    //   },
    //   transformResponse(response: InvisiblyApiResponse<GeoMapperItem>) {
    //     return response.item; // Return first item since we expect a single ProcessResponse
    //   },
    // }),
  }),
  overrideExisting: true,
});

export const {
  useGetScreenShotterUrlQuery,
  useCreateScreenshotterMutation,
  useGetScreenshotterItemsQuery,
  useGetScreenshotterItemQuery,
} = geoMapperEndpoints;